import { Injectable } from "@angular/core"
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router'
import { Store, Action } from "@ngrx/store"
import { Actions } from "@ngrx/effects"
import { Observable } from "rxjs/Observable"
import {
  FETCH_DIRECT_DEBIT_SUMMARY,
  POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY
} from "@reducers/transactions"
import { AppState } from "@store/app-state";
import { FetchDirectDebitSummaryParams } from "@services/transaction";

@Injectable()
export class DirectDebitSummaryViewResolver implements Resolve<boolean> {

  constructor(
    private store: Store<AppState>, 
    private router: Router,
    private actions: Actions,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const result =
      this.actions
        .ofType(POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY)
        .take(1)
        .mapTo(true)

    const payload: FetchDirectDebitSummaryParams = {
      id: route.params['id'],
    }

    this.store.dispatch(
      { type: FETCH_DIRECT_DEBIT_SUMMARY, payload })

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/direct-debit-summary-view.ts